export default __webpack_public_path__ + "static/media/Fireforge Axe.8b8c709a.jpg";